export enum PaymentType {
  money = 'money',
  points = 'points',
  EUROPE_UPGRADE = 'EUROPE_UPGRADE',
  LONG_HAUL_UPGRADE = 'LONG_HAUL_UPGRADE',
  COMPLIMENTARY = 'COMPLIMENTARY',
  UPGRADE_BENEFIT = 'UPGRADE_BENEFIT',
}
